import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { CostApproachModule } from '../../modules/costApproach/CostApproachModule.tsx';

export const CostApproachRouteElement = () => {
  return (
    <ModuleContainer moduleID="cost-approach">
      <CostApproachModule />
    </ModuleContainer>
  );
};
